import { useMemo } from 'react'; 
import { useMutation } from '@apollo/client';
import COMPONENT_LIST_SET_PATCH from '../mutations/COMPONENT_LIST_SET_PATCH';

const useComponentListSetPatch = () => {
    const [ patchComponentList ] = useMutation( COMPONENT_LIST_SET_PATCH );

    const patchCLS = async ( saveData ) => {
        try {
            const response = await patchComponentList( { variables: { input: saveData } } );
            const success = response?.data?.patchComponentListSet;

            if ( success ) {
                return {
                    success: true,
                    response: response.data.patchComponentListSet
                };
            } else {
                return {
                    success: false,
                    response
                };
            }
        } catch ( error ) { 
            console.error( 'Error patching component list', error );  
            return {
                success: false,
                response: false
            };
        } 
    };

    return useMemo( () => {
        return {
            patchCLS         
        };
    }, [] );
};

export default useComponentListSetPatch;
